import { FC } from 'react'
import { ApplicationFrame } from '../../components/ApplicationFrame'
import stuartHeroImage from '../../assets/stuart-delivery/image.png'
import { Typography } from '@mui/material'

/**
 * Uber Eats Application
 */
export const StuartDelivery: FC = () => {
  //   const [params] = useSearchParams()
  //   const session = params.get('session')!

  /**
   *
   */
  return (
    <ApplicationFrame heroImage={stuartHeroImage} backgroundColor="#0092ff">
      {/* Centralised Title with padding */}
      <Typography variant="h4" align="center" sx={{ p: 2 }}>
        Stuart Delivery
      </Typography>
    </ApplicationFrame>
  )
}
